import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedComics from './components/FeaturedComics';
import LatestUpdates from './components/LatestUpdates';
import { featuredComicIds, hotComicIds, latestComicIds } from '@/mocks/comics';
import { Link } from 'react-router-dom';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '洞洞杂货铺漫画 - 36漫画网',
    url: 'https://36manhua.com',
    description: '36漫画网支持洞洞杂货铺漫画全集在线免费阅读，完整剧情无遗漏，随时随地畅享追漫乐趣。',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://36manhua.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '36漫画网',
    url: 'https://36manhua.com',
    description: '优质漫画在线阅读平台，提供海量漫画全集免费阅读服务。',
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://36manhua.com',
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="漫画全集在线免费阅读"
        description="36漫画网支持洞洞杂货铺漫画全集在线免费阅读，完整剧情无遗漏，随时随地畅享追漫乐趣。涵盖热血、搞笑、恋爱、奇幻等多种类型漫画，高清画质流畅阅读体验。"
        keywords="洞洞杂货铺,漫画全集,在线免费阅读,36漫画网,免费漫画"
        canonicalUrl="https://36manhua.com"
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <HeroSection />
          <CategoryNav />
          <FeaturedComics
            comicIds={featuredComicIds}
            title="主编推荐"
            subtitle="精选优质漫画，不容错过的精彩故事"
          />
          <FeaturedComics
            comicIds={hotComicIds}
            title="热门漫画"
            subtitle="万人追捧的热门连载，大家都在看"
          />
          <LatestUpdates comicIds={latestComicIds} />

          <section className="py-10 md:py-14 bg-secondary-100">
            <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
                为什么选择36漫画网？
              </h2>
              <p className="text-sm text-foreground-600 mb-8">海量漫画资源，优质阅读体验</p>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                {[
                  { icon: 'ri-book-open-line', title: '海量资源', desc: '数万部漫画任你选' },
                  { icon: 'ri-speed-up-line', title: '极速更新', desc: '同步连载每日更新' },
                  { icon: 'ri-smartphone-line', title: '多端阅读', desc: '手机电脑随时随地看' },
                  { icon: 'ri-shield-check-line', title: '完全免费', desc: '无需付费畅享阅读' },
                ].map((item, i) => (
                  <div key={i} className="p-5 rounded-lg bg-background-50">
                    <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-100">
                      <i className={`${item.icon} text-primary-500 text-xl`}></i>
                    </div>
                    <h4 className="text-base font-heading text-foreground-900 mb-1">{item.title}</h4>
                    <p className="text-xs text-foreground-500">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14 bg-background-50">
            <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
                开始你的漫画之旅
              </h2>
              <p className="text-sm text-foreground-600 mb-6">
                加入数百万读者，一起探索洞洞杂货铺的奇妙世界
              </p>
              <Link
                to="/comic/dongdong-zahuopu"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full text-base font-label whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                <i className="ri-play-circle-line"></i>立即免费阅读
              </Link>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}